"use client"

import { Kayak } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `KayakIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const KayakIcon = component(Icon)({ as: Kayak })
